import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('activities', storeModule.createStoreModule('activities'))
